import { InfoIcon } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip';

const PermissionTooltip = () => {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button type="button" aria-label="Permission details" className="shrink-0 cursor-pointer">
            <InfoIcon className="size-3" />
          </button>
        </TooltipTrigger>
        <TooltipContent side="top" align="center" className="max-w-65 py-2">
          <p className="text-xs">
            <strong>Manager</strong> — Manages members on your side, plus settings, approvals, and change requests.
            <br />
            <br />
            <strong>Technical</strong> — Settings, approvals, and change requests.
            <br />
            <br />
            <strong>Legal</strong> — Settings, approvals, and change requests.
            <br />
            <br />
            <strong>Viewer</strong> — Read-only access; can download the agreement.
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default PermissionTooltip;
